import { render, staticRenderFns } from "./areaTree.vue?vue&type=template&id=c07efb76&scoped=true&"
import script from "./areaTree.vue?vue&type=script&lang=js&"
export * from "./areaTree.vue?vue&type=script&lang=js&"
import style0 from "./areaTree.vue?vue&type=style&index=0&id=c07efb76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07efb76",
  null
  
)

export default component.exports